export const ShoppingBag = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="3" y="3" width="26" height="26" rx="1" stroke="currentColor" stroke-width="2"/>
  <path d="M20.6667 6.66663V12C20.6667 14.2091 18.8758 16 16.6667 16H15.3333C13.1242 16 11.3333 14.2091 11.3333 12V6.66663" stroke="currentColor" stroke-width="2"/>
</svg>`;
